<!-- eslint-disable vue/no-template-key -->
<template>
  <div class="payment-methods-container">
    <div class="w-full">
      <div class="headline-m mb-4">
        วิธีการชำระเงิน
      </div>

      <div class="parent-container">
        <template v-if="isShowPayAtStoreMethod">
          <div
            :class="[
              'item-container pay-at-store',
              { '-is-selected': isSelectedPayAtStoreList },
            ]"
          >
            <div
              class="item"
              @click="onSelectPaymentMethod(payAtStoreList[0])"
            >
              <span class="checkmark"></span>
              <div>
                ชำระเงินที่สาขา
              </div>
              <div></div>
            </div>
            <div
              v-if="
                isSelectedPayAtStoreList && payAtStoreList.length > 1
              "
              class="item-desc"
            >
              <template v-for="item in payAtStoreList">
                <CheckoutPaymentMethodItem
                  :key="item.id"
                  :hasError="isErrorRequirePayment"
                  :name="item.title"
                  :image="iconBank[item.id]"
                  :selected="paymentId === item.id"
                  :label="item.short_description"
                  data-pptr="payment_type_id"
                  @click="onSelectPaymentMethod(item)"
                />
                <div
                  v-if="
                    paymentId === item.id &&
                      JSON.parse(item.dropdown) &&
                      JSON.parse(item.dropdown).length > 0
                  "
                  :key="`items-${item.id}`"
                  class="installment-plan-container"
                >
                  <label class="text-sm">
                    เลือกวิธีการผ่อนชำระ
                    <span class="text-red">*</span>
                  </label>
                  <v-select
                    v-model="installmentPlan"
                    :dense="true"
                    :items="JSON.parse(item.dropdown)"
                    color="primary"
                    class="text-sm"
                    background-color="white"
                    item-text="terms"
                    item-value="item"
                    placeholder="เลือกวิธีการผ่อนชำระ"
                    ref="items"
                    outlined
                    hide-details
                    return-object
                    @change="handleUpdateInstallmentPlan"
                  >
                    <template slot="selection" slot-scope="data">
                      ผ่อนชำระ {{ data.item.terms }} เดือน ดอกเบี้ย
                      {{ Number(data.item.interest) }}%
                    </template>
                    <template slot="item" slot-scope="data">
                      ผ่อนชำระ {{ data.item.terms }} เดือน ดอกเบี้ย
                      {{ Number(data.item.interest) }}%
                    </template>
                  </v-select>
                </div>
              </template>
            </div>
          </div>
        </template>

        <template v-else>
          <template v-if="fullPaymentList.length > 0">
            <div
              :class="[
                'item-container',
                { '-is-selected': isSelectedFullPaymentList },
              ]"
            >
              <div
                class="item"
                @click="onSelectPaymentMethod(fullPaymentList[0])"
              >
                <span class="checkmark"></span>
                <div>
                  ชำระเงินแบบเต็มจำนวน
                </div>
              </div>
              <div v-if="isSelectedFullPaymentList" class="item-desc">
                <template v-for="item in fullPaymentList">
                  <CheckoutPaymentMethodItem
                    :key="item.id"
                    :hasError="isErrorRequirePayment"
                    :name="item.title"
                    :image="iconBank[item.id]"
                    :selected="paymentId === item.id"
                    :label="item.short_description"
                    data-pptr="payment_type_id"
                    @click="onSelectPaymentMethod(item)"
                  />

                  <div
                    v-if="
                      paymentId === item.id &&
                        JSON.parse(item.dropdown) &&
                        JSON.parse(item.dropdown).length > 0
                    "
                    :key="`items-${item.id}`"
                    class="installment-plan-container"
                  >
                    <label class="text-sm">
                      เลือกวิธีการผ่อนชำระ
                      <span class="text-red">*</span>
                    </label>
                    <v-select
                      v-model="installmentPlan"
                      :dense="true"
                      :items="JSON.parse(item.dropdown)"
                      color="primary"
                      class="text-sm"
                      background-color="white"
                      item-text="terms"
                      item-value="item"
                      placeholder="เลือกวิธีการผ่อนชำระ"
                      ref="items"
                      outlined
                      hide-details
                      return-object
                      @change="handleUpdateInstallmentPlan"
                    >
                      <template slot="selection" slot-scope="data">
                        ผ่อนชำระ {{ data.item.terms }} เดือน ดอกเบี้ย
                        {{ Number(data.item.interest) }}%
                      </template>
                      <template slot="item" slot-scope="data">
                        ผ่อนชำระ {{ data.item.terms }} เดือน ดอกเบี้ย
                        {{ Number(data.item.interest) }}%
                      </template>
                    </v-select>
                  </div>
                </template>
              </div>
            </div>
          </template>

          <template v-if="installmentList.length > 0">
            <div
              :class="[
                'item-container',
                { '-is-selected': isSelectedInstallmentList },
              ]"
            >
              <div
                class="item"
                @click="onSelectPaymentMethod(installmentList[0])"
              >
                <span class="checkmark"></span>
                <div>
                  ผ่อนชำระด้วยบัตรเครดิต
                </div>
                <div></div>
              </div>
              <div v-if="isSelectedInstallmentList" class="item-desc">
                <template v-for="item in installmentList">
                  <CheckoutPaymentMethodItem
                    :key="`item-${item.id}`"
                    :hasError="isErrorRequirePayment"
                    :name="item.title"
                    :image="iconBank[item.id]"
                    :selected="paymentId === item.id"
                    :label="item.short_description"
                    data-pptr="payment_type_id"
                    @click="onSelectPaymentMethod(item)"
                  />

                  <div
                    v-if="
                      paymentId === item.id &&
                        JSON.parse(item.dropdown) &&
                        JSON.parse(item.dropdown).length > 0
                    "
                    :key="`items-${item.id}`"
                    class="installment-plan-container"
                  >
                    <label class="text-sm">
                      เลือกวิธีการผ่อนชำระ
                      <span class="text-red">*</span>
                    </label>
                    <v-select
                      v-model="installmentPlan"
                      :dense="true"
                      :items="JSON.parse(item.dropdown)"
                      color="primary"
                      class="text-sm"
                      background-color="white"
                      item-text="terms"
                      item-value="item"
                      placeholder="เลือกวิธีการผ่อนชำระ"
                      ref="items"
                      outlined
                      hide-details
                      return-object
                      @change="handleUpdateInstallmentPlan"
                    >
                      <template slot="selection" slot-scope="data">
                        ผ่อนชำระ {{ data.item.terms }} เดือน ดอกเบี้ย
                        {{ Number(data.item.interest) }}%
                      </template>
                      <template slot="item" slot-scope="data">
                        ผ่อนชำระ {{ data.item.terms }} เดือน ดอกเบี้ย
                        {{ Number(data.item.interest) }}%
                      </template>
                    </v-select>
                  </div>
                </template>
              </div>
            </div>
          </template>

          <template v-if="appList.length > 0">
            <div
              :class="[
                'item-container',
                {
                  '-is-selected': isSelectedAppList,
                },
              ]"
            >
              <div
                class="item"
                @click="onSelectPaymentMethod(appList[0])"
              >
                <span class="checkmark"></span>
                <div>
                  ชำระผ่านแอพพลิเคชั่น
                </div>
                <div></div>
              </div>
              <div v-if="isSelectedAppList" class="item-desc">
                <template v-for="item in appList">
                  <CheckoutPaymentMethodItem
                    :key="item.id"
                    :hasError="isErrorRequirePayment"
                    :name="item.title"
                    :image="iconBank[item.id]"
                    :selected="paymentId === item.id"
                    :label="item.short_description"
                    data-pptr="payment_type_id"
                    @click="onSelectPaymentMethod(item)"
                  />

                  <div
                    v-if="
                      paymentId === item.id &&
                        JSON.parse(item.dropdown) &&
                        JSON.parse(item.dropdown).length > 0
                    "
                    :key="`items-${item.id}`"
                    class="installment-plan-container"
                  >
                    <label class="text-sm">
                      เลือกวิธีการผ่อนชำระ
                      <span class="text-red">*</span>
                    </label>
                    <v-select
                      v-model="installmentPlan"
                      :dense="true"
                      :items="JSON.parse(item.dropdown)"
                      color="primary"
                      class="text-sm"
                      background-color="white"
                      item-text="terms"
                      item-value="item"
                      placeholder="เลือกวิธีการผ่อนชำระ"
                      ref="items"
                      outlined
                      hide-details
                      return-object
                      @change="handleUpdateInstallmentPlan"
                    >
                      <template slot="selection" slot-scope="data">
                        ผ่อนชำระ {{ data.item.terms }} เดือน ดอกเบี้ย
                        {{ Number(data.item.interest) }}%
                      </template>
                      <template slot="item" slot-scope="data">
                        ผ่อนชำระ {{ data.item.terms }} เดือน ดอกเบี้ย
                        {{ Number(data.item.interest) }}%
                      </template>
                    </v-select>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>

    <template v-if="isVerifyRecaptcha">
      <Recaptcha @validate="validate" />
    </template>

    <div ref="beforeCheckoutAction"></div>

    <!-- Summary for mobile size -->
    <div v-if="isMobile || isTablet">
      <slot></slot>
    </div>

    <div class="payment-methods-actions-container">
      <BaseStaffQrCode />

      <v-btn
        depressed
        :dark="true"
        color="primary"
        :disabled="disabledButton"
        :loading="loading"
        @click="checkValid ? onSubmit() : false"
      >
        ชำระเงินค้ำประกัน
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import iconBank from '@/config/iconBank'
import Recaptcha from '@/components/Recaptcha'
import screenSize from '@/mixins/screenSize'
import { showKBankEmbedUI } from '@/utils/kbank'
import { STOCK_CARD_TYPE } from '@/config/stockCard'

export default {
  name: 'PaymentGuaranteeMethods',

  mixins: [screenSize],

  props: {
    loading: Boolean,
    isErrorRequirePayment: Boolean,
  },

  components: {
    BaseStaffQrCode: () =>
      import('@/components/base/BaseStaffQrCode'),
    CheckoutPaymentMethodItem: () =>
      import('@/components/studio7/CheckoutPaymentMethodItem'),
    Recaptcha,
  },

  computed: {
    ...mapState({
      campaign: state => state.campaign.current,
      paymentId: state => state.paymentType.paymentId,
    }),

    ...mapGetters({
      paymentTypeData: 'paymentType/getGuaranteePaymentMethods',
    }),

    depositList() {
      return (
        this.paymentTypeData?.filter(i => i?.type === 'deposit') ?? []
      )
    },

    isSelectedDepositList() {
      return this.depositList.some(item => item.id === this.paymentId)
    },

    fullPaymentList() {
      return (
        this.paymentTypeData?.filter(
          i => i?.type === 'full-payment',
        ) ?? []
      )
    },

    isSelectedFullPaymentList() {
      return this.fullPaymentList.some(
        item => item.id === this.paymentId,
      )
    },

    payAtStoreList() {
      return (
        this.paymentTypeData?.filter(
          i => i?.type === 'pay-at-store',
        ) ?? []
      )
    },

    isSelectedPayAtStoreList() {
      return this.payAtStoreList.some(
        item => item.id === this.paymentId,
      )
    },

    installmentList() {
      return (
        this.paymentTypeData?.filter(
          i => i?.type === 'installment',
        ) ?? []
      )
    },

    isSelectedInstallmentList() {
      return this.installmentList.some(
        item => item.id === this.paymentId,
      )
    },

    appList() {
      return []
    },

    isSelectedAppList() {
      return this.appList.some(item => item.id === this.paymentId)
    },

    appListDeposit() {
      return []
    },

    isSelectedAppListDeposit() {
      return this.appListDeposit.some(
        item => item.id === this.paymentId,
      )
    },

    disabledButton() {
      if (this.isVerifyRecaptcha) {
        return !this.checkAgree || !this.validateRecaptcha
      }
      return !this.checkAgree
    },

    checkValid() {
      if (this.isVerifyRecaptcha) {
        return this.checkAgree && this.validateRecaptcha
      }
      return this.checkAgree
    },

    isVerifyRecaptcha() {
      return this.campaign?.data?.is_verify_recaptcha === 1
    },

    isShowPayAtStoreMethod() {
      const { t } = this.$route.query

      return (
        this.payAtStoreList.length > 0 &&
        (t === STOCK_CARD_TYPE.STORE || t === STOCK_CARD_TYPE.QR)
      )
    },

    form() {
      return {
        order_id:
          this.$route.params?.uid ||
          this.$route.params?.orderId ||
          null,
        payment_gw: this.paymentId == 4 ? 'kbank' : null,
      }
    },
  },

  async mounted() {
    this.autoSelectPayment()
  },

  data() {
    return {
      iconBank,
      scrollY,
      validateRecaptcha: false,
      checkAgree: true,
      isShowTerm: false,
      positionCheckoutAction: 0,
      installmentPlan: null,
    }
  },

  methods: {
    validate(success) {
      this.validateRecaptcha = success
    },

    onSelectPaymentMethod(event) {
      this.$store.commit('paymentType/setPaymentId', event.id)
      this.$emit('onSelectPaymentMethod', event.id)

      let plan = event.dropdown ? JSON.parse(event.dropdown) : null
      if (plan) {
        this.$store.commit(
          'paymentType/setPaymentInstallmentPlan',
          plan?.[0],
        )
        this.installmentPlan = plan?.[0]
      } else {
        this.$store.commit(
          'paymentType/setPaymentInstallmentPlan',
          null,
        )
        this.installmentPlan = null
      }

      this.$forceUpdate()
    },

    autoSelectPayment() {
      this.onSelectPaymentMethod(this.fullPaymentList[0])
    },

    handleUpdateInstallmentPlan(value) {
      this.$store.commit(
        'paymentType/setPaymentInstallmentPlan',
        value,
      )
    },

    async onSubmit() {
      switch (this.paymentId) {
        case 4:
          await this.handlePayWithKBank()
          break
        default:
          await this.handlePayWithKBank()
      }
    },

    async handlePayWithKBank() {
      try {
        const response = await axios
          .post('/payment/guarantee/pay', this.form)
          .then(res => res.data.data)

        if (Object.keys(response).length === 0) {
          this.$toast.error(
            'เกิดข้อผิดพลาดในการชำระเงิน กรุณาลองใหม่อีกครั้ง',
            {
              duration: 5000,
              position: 'top',
            },
          )
          return
        }

        this.handlePayWithKBankEmbedUI(response)
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          'เกิดข้อผิดพลาดในการชำระเงิน กรุณาลองใหม่อีกครั้ง'

        this.$toast.error(errorMessage, {
          duration: 5000,
          position: 'top',
        })
      }
    },

    handlePayWithKBankEmbedUI(event) {
      try {
        const embeds = {
          ref_id: event?.ref_id,
          merchant_id: event?.merchant_id,
          apiKey: event?.public_apikey,
          amount: event?.amount,
          currency: event?.currency,
          smartpayId: event?.smartpay_id,
          smartpayTerm: event?.smartpay_term,
          scriptUrl: event?.script_url,
          endpoint: event?.action_url,
        }

        showKBankEmbedUI(embeds)
      } catch {
        this.$toast.error(
          'เกิดข้อผิดพลาดในการชำระเงิน กรุณาลองใหม่อีกครั้ง',
          {
            duration: 5000,
            position: 'top',
          },
        )
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.payment-methods-container {
    display flex
    flex-direction column
    gap 16px

    .parent-container {
        .item-container {

            &:not(:first-of-type):not(:last-of-type){

            }

            &:not(.-is-selected):not(:last-of-type) {
                .item {
                    border-bottom: 0;
                }
            }

            &:first-of-type {
                .item {
                    border-radius: 8px 8px 0 0;
                }
            }

            &:last-child:not(:first-child) {
                > .item {
                    border-radius: 0 0 8px 8px;
                }

                &.-is-selected {
                    > .item {
                        border-radius: 0;
                    }

                    .item-desc {
                        border-radius: 0 0 8px 8px;
                    }
                }
            }

            &:first-of-type:last-child {
                .item-desc {
                    border-radius: 0 0 8px 8px;
                }
            }

            &.-is-selected {
                .item {
                    background-color: $color-fill-radio-button;
                    border: 1.2px solid $color-bnn;

                    .checkmark {
                        border: 5.5px solid $color-bnn;
                    }
                }
            }

            &not(:last-child):not(:first-child) {
                .item {
                    border-top 0
                }
            }

            &.-is-selected:not(:last-child){
                .item-desc {
                    border-bottom: none
                    border-top: none
                }
            }

            &.pay-at-store {
                .item {
                    border-radius: 8px;
                }
            }
        }
    }


    .item {
        display: flex;
        align-items: center;
        gap: 11px;
        padding: 11px;

        border: 1.2px solid $color-dapp-gray-3;
        cursor: pointer;

        &.-is-disabled {
            opacity: 0.4;
            cursor: not-allowed;
            pointer-events: none;
        }

        .item-label {
            flex: 1;

            > .label {
                font-weight: 500;
                color: rgba(#000000, 0.70);
            }

            > .description-s {

                font-size: 12px;
                font-weight: 600;
                line-height: 1.3;
                color: rgba(#000000, 0.45);
            }
        }

        .item-icon {
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                object-fit: contain;
                width: 100%;
                height: 100%;
            }
        }

        .checkmark {
            width 16px;
            height 16px;
            border-radius: 50%;
            border: 1px solid #d2d2d7;
            transition: border .1s;
        }

    }

    .base-radio-button {
        position: relative;
        display: block;
        cursor: pointer;
        user-select: none;

        &.-is-disabled {
            cursor: not-allowed;

            > .label {
                color: $color-absolute-black-45;
            }
        }

        // Hide the browser's default radio
        input {
            display: none;
            opacity: 0;
            width: 0;
            height: 0;
            cursor: pointer;
        }

        // Create a custom radio
        .checkmark {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            height:  16px;
            width: 16px;

            display: flex;
            align-items: center;
            justify-content: center;

            background-color: transparent;
            border-radius: 50%;
            border: 1px solid $color-grey83;
            transition: border 0.1s;
        }

        & input:checked ~ .checkmark {
            border: rem(5.5) solid $color-bnn;
        }

        & input:focus ~ .checkmark {
            box-shadow: 0 0 0 rem(3) $color-functionality-secondary;
        }


        & input:not(:checked):disabled ~ .checkmark {
            border: 2px solid $color-grey-light-50;
        }

        & input:checked:disabled ~ .label,
        & input:not(:checked):disabled ~ .label {
            color: $color-grey-light-50;
        }


        & input:checked:disabled ~ .checkmark {
            border: rem(7) solid $color-grey-light-50;
        }
    }

    .item-desc {
        background-color rgba(0, 0, 0, 0.043)
        border 1px solid rgb(222, 222, 222)
        box-sizing border-box
        color rgb(0, 0, 0)
        display block
        font-size 14px
        font-weight 400
        letter-spacing normal
        line-height 21px
        padding 17px

        width 100%
        display grid
        grid-template-columns: repeat(2, 1fr)
        gap: 12px 16px

        @media screen and (min-width: 1024px) {
            grid-template-columns: repeat(3, 1fr)
        }

        @media screen and (min-width: 1280px) {
            grid-template-columns: repeat(4, 1fr)
        }
    }

    .installment-plan-container {
        grid-column span 2
        order: 1

        @media screen and (min-width: 1024px) {
            grid-column span 3
        }

        @media screen and (min-width: 1280px) {
            grid-column span 4
        }
    }
}

.section-summary {
    width 100%
    max-width: 100dvw

    display flex;
    flex-direction: column;
    gap: 32px;
}

.payment-methods-actions-container {
    display flex;
	flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;

	::v-deep .staff-qr-code-container {
		order: 1
	}

    @media screen and (min-width: 768px) {
	    flex-direction: row;
        justify-content: space-between;

		::v-deep .staff-qr-code-container {
			order: 0
		}
    }

	.btn-link {
		font-weight: 600;
		font-size: 14px;
	}
}
</style>
